import { Warehouse } from "@domain/inventory/models/Warehouse";
import { WarehouseDTO } from "../dto/WarehouseDTO";
import { WarehouseConnectionMapper } from "./WarehouseConnectionMapper";

export class WarehouseMapper {
  static toModel(dto: WarehouseDTO): Warehouse {
    return {
      id: dto.id,
      name: dto.name,
      location: dto.location,
      active: dto.active,
      createdAt: new Date(dto.createdAt),
      warehouseConnections: dto.connections?.map(WarehouseConnectionMapper.toModel)
    };
  }

} 